export function pickFirstCzechLanguage(items) {
    var _a;
    if (!(items === null || items === void 0 ? void 0 : items.length))
        return undefined;
    var isCzechLanguage = function (item) {
        var _a, _b;
        var itemValueLower = ((_a = item.value) !== null && _a !== void 0 ? _a : "").toLowerCase();
        var itemDescriptionLower = ((_b = item.description) !== null && _b !== void 0 ? _b : "").toLowerCase();
        return (itemValueLower === "ces" ||
            itemValueLower === "cze" ||
            itemValueLower === "cs" ||
            itemDescriptionLower.includes("czech") ||
            itemDescriptionLower.includes("češt"));
    };
    return (_a = items.find(isCzechLanguage)) !== null && _a !== void 0 ? _a : items[0];
}
